import styled, { css } from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const PdfContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const PdfPageCounterContainer = styled.div`
  position: absolute;
  bottom: -50px;
  width: 100%;
  display: flex;
  justify-content: center;
`;

export const NextPdfButton = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 0 10px 10px 0;
  cursor: pointer;

  &:hover {
    background-color: #e6e6e6;
  }
`;

export const NextPdfPage = styled(FontAwesomeIcon)`
  font-size: 1rem;
  cursor: pointer;
  color: black;
`;

export const PreviousPdfButton = styled.div`
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  border-radius: 10px 0 0 10px;
  cursor: pointer;

  &:hover {
    background-color: #e6e6e6;
  }
`;

export const PreviousPdfPage = styled(FontAwesomeIcon)`
  font-size: 1rem;
  cursor: pointer;
  color: black;
`;

export const PageCounter = styled.div`
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: white;
  padding: 0 1rem;
`;

export const DocumentContainer = styled.div`
  width: 100%;
  height: 100%;
  ${(props) => props.hasClickAction && css`cursor: pointer;`}
`;

export const PdfFallback = styled.div`
  width: 100%;
  height: 100%;
  min-height: 8rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem;
  box-sizing: border-box;
  text-align: center;
`;

export const PdfFallbackMessage = styled.p`
  margin: 0;
  font-size: 0.9rem;
  color: #333;
`;

export const PdfFallbackActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0.5rem;
`;

const fallbackControl = css`
  height: 2.5rem;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
  background-color: white;
  color: black;
  font-size: 0.9rem;
  text-decoration: none;
  cursor: pointer;

  &:hover {
    background-color: #e6e6e6;
  }
`;

export const PdfFallbackLink = styled.a`
  ${fallbackControl}
`;

export const PdfFallbackButton = styled.button`
  ${fallbackControl}
  font-family: inherit;
`;
